// Rótulos da tela de benefícios da consignatária (#316, epic #312).
//
// "Benefício" é a palavra da tela dela; no código e no banco de dados,
// consignação facultativa (glossário). Ficam aqui para a lista, o detalhe e as
// próximas telas (encerrar #317, pedidos #318) dizerem a mesma coisa.

import type { OcupacaoMargem, SituacaoBeneficio } from "@atlas/sdk";

type VariantePill = "pendente" | "aceita" | "averbado" | "emdia" | "expirado" | "rejeitada";

/** "Ocupa margem?" — a resposta da regra do órgão, a mesma que o motor usa. */
export const OCUPA_MARGEM: Record<OcupacaoMargem, { rotulo: string; variante: VariantePill; explicacao: string }> = {
  nao_ocupa: {
    rotulo: "Não ocupa",
    variante: "expirado",
    explicacao: "A regra deste órgão não faz este tipo de benefício ocupar margem consignável.",
  },
  emprestimo: {
    rotulo: "Empréstimo",
    variante: "emdia",
    explicacao: "Ocupa a margem de empréstimo do servidor neste órgão — e, por ela, o crédito total.",
  },
  cartao_consignado: {
    rotulo: "Cartão consignado",
    variante: "emdia",
    explicacao: "Ocupa a margem de cartão consignado do servidor neste órgão.",
  },
  cartao_beneficios: {
    rotulo: "Cartão benefício",
    variante: "emdia",
    explicacao: "Ocupa a margem de cartão benefício do servidor neste órgão.",
  },
  teto_somado: {
    rotulo: "Teto somado",
    variante: "emdia",
    explicacao: "Ocupa só o teto somado das margens do servidor neste órgão.",
  },
  informada_pelo_orgao: {
    rotulo: "Informada pelo órgão",
    variante: "aceita",
    explicacao: "A margem deste órgão é informada pela folha, que já desconta o benefício. Encerrar devolve o valor na hora; incluir consome na hora.",
  },
  sem_classificacao: {
    rotulo: "Sem classificação",
    variante: "pendente",
    explicacao: "A rubrica ainda não tem tipo de serviço: a averbadora precisa classificá-la.",
  },
};

const mesAno = (aaaamm: string) => `${aaaamm.slice(4, 6)}/${aaaamm.slice(0, 4)}`;

export function situacaoDoBeneficio(s: SituacaoBeneficio, competenciaFim: string | null): { rotulo: string; variante: VariantePill } {
  switch (s) {
    case "ativa":
      return { rotulo: "Ativo", variante: "averbado" };
    case "encerrando":
      return { rotulo: competenciaFim ? `Encerrando (até ${mesAno(competenciaFim)})` : "Encerrando", variante: "pendente" };
    case "aguardando_autorizacao":
      return { rotulo: "Aguardando autorização do servidor", variante: "pendente" };
    case "pendente_identidade":
      return { rotulo: "Identidade pendente", variante: "rejeitada" };
    case "encerrada":
      return { rotulo: "Encerrado", variante: "expirado" };
  }
}

export const OPCOES_SITUACAO: { value: SituacaoBeneficio | ""; label: string }[] = [
  { value: "", label: "Em desconto ou a descontar" },
  { value: "ativa", label: "Ativos" },
  { value: "encerrando", label: "Encerrando" },
  { value: "aguardando_autorizacao", label: "Aguardando autorização" },
  { value: "pendente_identidade", label: "Identidade pendente" },
  { value: "encerrada", label: "Encerrados" },
];

export const ROTULO_COMPORTAMENTO: Record<string, string> = {
  recorrente: "Mensal",
  prazo: "Com prazo",
  avulsa: "Avulso",
};

export const ROTULO_ORIGEM_VALOR: Record<string, string> = {
  arquivo: "Arquivo mensal",
  carga: "Carga inicial",
  retorno: "Retorno da folha",
  reajuste: "Reajuste",
  manual: "Operação manual",
  legado: "Anterior à Atlas",
};

export const ROTULO_OPERACAO: Record<"inclusao" | "alteracao_valor" | "encerramento", string> = {
  inclusao: "Inclusão",
  alteracao_valor: "Alteração de valor",
  encerramento: "Encerramento",
};

export { mesAno };
